import * as theme from './theme'

const { switchTheme, ...rest } = theme

export default defineAppConfig({
    ui: {
        colors: {
            'primary': 'blue',
            'secondary': 'green',
            'red-lighter': 'red-lighter',
            'red-light': 'red-light',
            'red-base': 'red-base',
            'red-dark': 'red-dark',
            'blue-lighter': 'blue-lighter',
            'blue-light': 'blue-light',
            'blue-base': 'blue-base',
            'blue-dark': 'blue-dark',
            'green-lighter': 'green-lighter',
            'green-light': 'green-light',
            'green-base': 'green-base',
            'green-dark': 'green-dark',
            'extended': 'extended',
            'orange-lighter': 'orange-lighter',
            'orange-light': 'orange-light',
            'orange-base': 'orange-base',
            'orange-dark': 'orange-dark',
        },
        ...rest,
        switch: switchTheme,
    // as any: od @nuxt/ui 4.10 (nuxt/ui#6531) typ wejściowy defineAppConfig wymaga pełnej
    // konfiguracji ui (DeepRequired), a runtime poprawnie merguje częściową; usunąć po fixie upstream
    } as any,
})
